import { Col, Row } from "antd";
import dayjs from "dayjs";
import { get } from "lodash";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { DATE_FORMAT, SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import { notAfterTodayDisabledDate } from "utils/helpers/date";
import {
  getObsequesChildrenCount,
  shouldShowObsequesChildren,
} from "../../../obseques";

const Children = ({
  setPercent,
  isFieldRequired,
  bindField,
  initialValues,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const FC = SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.CHILDREN;
  const childrenCount = getObsequesChildrenCount(initialValues);

  useEffect(() => {
    if (!shouldShowObsequesChildren(initialValues)) return;
    setPercent(initialValues);
    // setPercent is recreated each render; only the child count should retrigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childrenCount]);

  if (!shouldShowObsequesChildren(initialValues)) return null;

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.CHILDREN}-section`}
    >
      <Form type="vertical" title={FC.TITLE} subtitle={FC.SUBTITLE}>
        <Row gutter={[16, 16]}>
          {Array.from({ length: childrenCount }, (_, index) => {
            const birthDatePath = `children.${index}.identity.user.birthDate`;
            const birthDateField = bindField(birthDatePath, {
              label: SUBSCRIPTION.FORM.BIRTH_DATE.LABEL,
              required: isFieldRequired(birthDatePath),
              onChange: () => setPercent(initialValues),
              onBlur: () => setPercent(initialValues),
            });
            const birthDate = get(initialValues, birthDatePath);

            return (
              <Col lg={24} xs={24} key={`child-form-${index}`}>
                <Form type="highlight" title={`${FC.CHILD.TITLE} ${index + 1}`}>
                  <Row gutter={[16, 16]}>
                    <Col lg={24} xs={24}>
                      <FormField
                        path={birthDateField.path}
                        label={birthDateField.label}
                        required={birthDateField.required}
                        disabled={birthDateField.disabled}
                      >
                        {(field) => (
                          <Input
                            label={birthDateField.label}
                            placeholder={
                              SUBSCRIPTION.FORM.BIRTH_DATE.PLACEHOLDER
                            }
                            type="date"
                            variant="simple"
                            defaultValue={
                              birthDate ? dayjs(birthDate) : undefined
                            }
                            format={DATE_FORMAT}
                            disabledDate={notAfterTodayDisabledDate}
                            {...field}
                            onChange={birthDateField.onChange}
                            onBlur={birthDateField.onBlur}
                          />
                        )}
                      </FormField>
                    </Col>
                  </Row>
                </Form>
              </Col>
            );
          })}
        </Row>
      </Form>
    </div>
  );
};

export default Children;
